<mat-sidenav-container style="background-color:#fff;">
  <div class="wrapper" [class.no-toolbar]="!isAuthenticated" [class.impersonating]="!!impersonationState" [class.modern-layout]="isModernLayoutRoute">

    <div class="toolbar" *ngIf="isAuthenticated && !isModernLayoutRoute">
      <mat-toolbar color="primary">
        <div class="col d-inline d-sm-none">
          <div class="d-flex justify-content-start">
            <div routerLink="" class="branding center">
              <img style="max-height: 50px; width: auto;" [src]="logo" />
            </div>
          </div>
        </div>
        <div class="d-sm-inline d-md-none d-lg-none" *ngIf="isAuthenticated">
          <button mat-icon-button [matMenuTriggerFor]="menu" class="hoverColorAccentThin" aria-label="icon-button with a menu">
            <mat-icon>view_headline</mat-icon>
          </button>
          <mat-menu #menu="matMenu" panelClass="app-mobile-menu">
            <span *ngFor="let item of navigationSideMenu">
              <button mat-menu-item class="nav-button hoverColorAccent" *ngIf="isAuthenticated"
                      [routerLink]="[item.link]" routerLinkActive="active">
                <mat-icon *ngIf="item.icon" color="accent">{{ item.icon }}</mat-icon> {{item.label}}
              </button>
            </span>
            <div class="col mobile-menu-footer">
              <button mat-menu-item class="nav-button hoverColorAccent mobile-menu-logout" (click)="onLogoutClick()">
                <mat-icon color="accent" class="hoverColorAccentThin">exit_to_app</mat-icon>
                <span>Logga ut</span>
              </button>
            </div>
          </mat-menu>
        </div>
        <span routerLink=""
              class="branding center d-none d-sm-inline d-md-none">
          <img style="max-height: 50px; width: auto;" [src]="logo" />
        </span>
        <span routerLink="" class="branding spacer d-none d-md-inline">
          <img style="max-height: 50px; width: auto;" [src]="logo" />
        </span>

        <div class="d-none d-md-inline d-lg-none justify-content-end" *ngIf="isAuthenticated">
          <button mat-icon-button [matMenuTriggerFor]="menu" class="hoverColorAccentThin" aria-label="icon-button with a menu">
            <mat-icon>view_headline</mat-icon>
          </button>
          <mat-menu #menu="matMenu" panelClass="app-mobile-menu">
            <span *ngFor="let item of navigationSideMenu">
              <button mat-menu-item class="nav-button hoverColorAccent" *ngIf="isAuthenticated"
                      [routerLink]="[item.link]" routerLinkActive="active">
                <mat-icon *ngIf="item.icon" color="accent">{{ item.icon }}</mat-icon> {{item.label}}
              </button>
            </span>
            <div class="col mobile-menu-footer">
              <button mat-menu-item color="accent" class="nav-button hoverColorAccent mobile-menu-logout" (click)="onLogoutClick()">
                <mat-icon class="hoverColorAccentThin">exit_to_app</mat-icon>
                <span>Logga ut</span>
              </button>
            </div>
          </mat-menu>
        </div>

        <div class="d-none d-md-none d-lg-inline">
          <div *ngIf="isAuthenticated">

            <!--<button *ngIf="!isProd" mat-icon-button class="nav-button nav-button-light"
                    title="Chatsupport"
                    (click)="openChatBot();">
              <mat-icon>chat</mat-icon>
            </button>-->

            <span *ngFor="let item of navigation">
              <button mat-icon-button class="nav-button" title="{{ item.title }}" *ngIf="isAuthenticated"
                      [routerLink]="[item.link]" routerLinkActive="active">
                <span class="nav-icon-wrapper" *ngIf="item.icon">
                  <mat-icon>{{ item.icon }}</mat-icon>
                  <span
                    *ngIf="item.link === 'admin/task-center' && pendingEmployerCertificateCount > 0"
                    class="nav-pending-badge" role="img" [attr.aria-label]="pendingEmployerCertificateCount + ' ärenden i Task Center kräver åtgärd'">
                    {{pendingEmployerCertificateCount}}
                  </span>
                </span>
              </button>
            </span>
            
            <button mat-icon-button class="nav-button"
                    title="Hantera medarbetare"
                    *ngIf="appId == 2 && isAuthenticated && isCompanyAdmin"
                    (click)="openOrganizationModal()">
              <mat-icon>group_add</mat-icon>
            </button>

            <!-- settings menu -->
            <button *ngIf="navigation.length > 0" mat-icon-button [matMenuTriggerFor]="menu" title="Fler alternativ" class="hoverColorAccentThin" style="margin-right: 13px;" aria-label="icon-button with a menu">
              <mat-icon>view_headline</mat-icon>
            </button>
            <mat-menu #menu="matMenu" xPosition="before">
              <span *ngFor="let item of navigtionMenu">
                <button mat-menu-item class="nav-button hoverColorAccent"
                        [routerLink]="[item.link]" routerLinkActive="active">
                  <mat-icon *ngIf="item.icon" color="accent">{{ item.icon }}</mat-icon> {{item.label}}
                </button>
              </span>
            </mat-menu>
            <button mat-icon-button title="Logga ut" class="nav-button" (click)="onLogoutClick()">
              <mat-icon color="accent" class="hoverColorWhite">exit_to_app</mat-icon>
            </button>
          </div>
        </div>

      </mat-toolbar>
      <div *ngIf="impersonationState as state" class="impersonation-banner" role="status" aria-live="polite">
        <div class="impersonation-message">
          <mat-icon aria-hidden="true">manage_accounts</mat-icon>
          <span>
            Du är inloggad som <strong>{{state.targetDisplayName}}</strong>
            <span *ngIf="state.targetEmail"> ({{state.targetEmail}})</span>
            på uppdrag av {{state.actorDisplayName}}.
          </span>
        </div>
        <button mat-flat-button
                type="button"
                color="primary"
                [disabled]="isStoppingImpersonation"
                (click)="stopImpersonation()">
          <mat-icon>undo</mat-icon>
          Återgå till admin
        </button>
      </div>
    </div>

    
    <div class="content" [@.disabled]="isModernLayoutRoute" [@routeAnimations]="o.isActivated && o.activatedRoute.routeConfig.path">
      <anms-design-test [shellOnly]="!!isAuthenticated">
        <router-outlet #o="outlet"></router-outlet>
      </anms-design-test>
    </div>

    <div class="footer" *ngIf="isAuthenticated && !isModernLayoutRoute">
      <div class="row">
        <div class="col-sm-12 links">
        </div>
      </div>
      <div class="row d-flex justify-content-center">
        <div class="footer-padding col-6 d-flex justify-content-center signature">
          &#169; <span class="year">{{year}} - <a class="sPoolFooter" href="https://www.sampoolen.se/">SAMgruppen AB</a></span>
          <br class="d-block d-sm-none">
          <!--<button mat-button class="sign-in-button "
                  (click)="openChatBot();">
            Chatbot
          </button>-->
        </div>
      </div>
    </div>

    <chatbot-component *ngIf="!isModernLayoutRoute" [show]="showChatBot" [conversation]="chatConversation" (close)="onChatBotClose($event)"></chatbot-component>

  </div>

</mat-sidenav-container>
